import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { Check } from '../../../context/Chakra/Icons';

const CustomIcon = (props) => {
  const { isChecked, ...restProps } = props;
  const checkProps = { ...restProps };
  delete checkProps.isIndeterminate;

  if (isChecked) {
    return <Check boxSize="10px" {...checkProps} />;
  }

  return null;
};

CustomIcon.propTypes = {
  isChecked: PropTypes.bool,
};

const Checkbox = (props) => {
  return <ChakraCheckbox icon={<CustomIcon />} {...props} />;
};

export default Checkbox;
